import React from "react";
import useOriQaEnabled from "apps/user/learner/hooks/use-ori-qa-enabled";
import { useTranslation } from "lib/i18n/use-translation";
import styles from "./OriQaModeToggle.module.scss";

interface OriQaModeToggleProps {
  qaMode: boolean;
  onChange: (on: boolean) => void;
}

// The single top-level QA control: switches the chat's context between the
// user's continuous thread ("Chat") and a bounded QA thread ("QA"). Rendered
// only under the ori_qa flag — nothing shows for a normal user.
const OriQaModeToggle: React.FC<OriQaModeToggleProps> = ({
  qaMode,
  onChange,
}) => {
  const { t } = useTranslation(["ori"]);
  const { enabled, loading } = useOriQaEnabled();
  if (loading || !enabled) return null;

  return (
    <div
      className={styles.toggle}
      role="group"
      aria-label="Conversation context"
      data-testid="ori-qa-mode-toggle"
    >
      <button
        type="button"
        className={styles.option}
        aria-pressed={!qaMode}
        onClick={() => onChange(false)}
        data-testid="ori-qa-mode-chat"
      >
        {t("ori:qa.modeChat")}
      </button>
      <button
        type="button"
        className={styles.option}
        aria-pressed={qaMode}
        onClick={() => onChange(true)}
        data-testid="ori-qa-mode-qa"
      >
        QA
      </button>
    </div>
  );
};

export default OriQaModeToggle;
